const mdMonthlySale = {
	labelEn: 'Monthly Sale Report for Insurance Company',
	labelKh: 'របាយការណ៍អាជីវកម្មប្រចាំខែរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'MdMonthlySale',
};
const mdMonthlyClaim = {
	labelEn: 'Monthly Receiving and Settling Claim Report for Insurance Company',
	labelKh: 'របាយការណ៍ទទួល និងដោះស្រាយសំណងប្រចាំខែរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'MdMonthlyClaim',
};
const mdMonthlyDistribution = {
	labelEn: 'Monthly Distribution Channels and Geographical Report for Insurance Company',
	labelKh: 'របាយការណ៍លក់តាមប្រព័ន្ធចែកចាយ និងតាមភូមិសាស្ត្រប្រចាំខែរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'MdMonthlyDistribution',
};
const mdQuarterlySale = {
	labelEn: 'Quarterly Sale Report for Insurance Company',
	labelKh: 'របាយការណ៍អាជីវកម្មប្រចាំត្រីមាសរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'MdQuarterlySale',
};
const mdQuarterlyClaim = {
	labelEn: 'Quarterly Receiving and Settling Claim Report for Insurance Company',
	labelKh: 'របាយការណ៍អំពីការទទួល និងដោះស្រាយសំណងធានារ៉ាប់រងប្រចាំត្រីមាសរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'MdQuarterlyClaim',
};
const mdAnnualSale = {
	labelEn: 'Annual Audited Sale Report for Insurance Company',
	labelKh: 'របាយការណ៍អាជីវកម្មប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម',
	value: 'MdAnnualSale',
};
const mdAnnualClaim = {
	labelEn: 'Annual Audited Receiving and Settling Claim Report for Insurance Company',
	labelKh: 'របាយការណ៍ទទួល និងដោះស្រាយសំណងប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម',
	value: 'MdAnnualClaim',
};
const mdAnnualDistribution = {
	labelEn: 'Annual Audited Distribution Channels and Geographical Report for Insurance Company',
	labelKh: 'របាយការណ៍លក់តាមប្រព័ន្ធចែកចាយ និងតាមភូមិសាស្ត្រប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម',
	value: 'MdAnnualDistribution',
};
const sdQuarterlyFinance = {
	labelEn: 'Quarterly Financial Statements for Insurance Company',
	labelKh: 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំត្រីមាសរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'SdQuarterlyFinance',
};
const sdQuarterlyInvestment = {
	labelEn: 'Quarterly Report on Investment for Insurance Company',
	labelKh: 'របាយការណ៍វិនិយោគប្រចាំត្រីមាសរបស់ក្រុមហ៊ុនធានារ៉ាប់រង',
	value: 'SdQuarterlyInvestment',
};
const sdAnnualAuditedFinance = {
	labelEn: 'Annual Audited Financial Statement for Insurance Company',
	labelKh: 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម',
	value: 'SdAnnualAuditedFinance',
};
const sdAnnualUnauditedFinance = {
	labelEn: 'Annual Un-audited Financial Statement for Insurance Company',
	labelKh: 'របាយការណ៍ហិរញ្ញវត្ថុប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងមិនទាន់រងសវនកម្ម',
	value: 'SdAnnualUnauditedFinance',
};
const sdAnnualAuditedInvestment = {
	labelEn: 'Annual Audited Report on Investment for Insurance Company',
	labelKh: 'របាយការណ៍វិនិយោគប្រចាំឆ្នាំរបស់ក្រុមហ៊ុនធានារ៉ាប់រងរងសវនកម្ម',
	value: 'SdAnnualAuditedInvestment',
};

const monthlyFileReport = {
	labelEn: 'Monthly Report (Document Upload)',
	labelKh: 'របាយការណ៍ប្រចាំខែ (ប្រភេទឯកសារ)',
	value: 'MonthlyFileReport',
};

const quarterlyFileReport = {
	labelEn: 'Quarterly Report (Document Upload)',
	labelKh: 'របាយការណ៍ប្រចាំត្រីមាស (ប្រភេទឯកសារ)',
	value: 'QuarterlyFileReport',
};

const semesterlyFileReport = {
	labelEn: 'Semesterly Report (Document Upload)',
	labelKh: 'របាយការណ៍ប្រចាំឆមាស (ប្រភេទឯកសារ)',
	value: 'SemesterlyFileReport',
};

const annuallyFileReport = {
	labelEn: 'Annual Report (Document Upload)',
	labelKh: 'របាយការណ៍ប្រចាំឆ្នាំ (ប្រភេទឯកសារ)',
	value: 'AnnuallyFileReport',
};

const reportTypes = [
	mdMonthlySale,
	mdMonthlyClaim,
	mdMonthlyDistribution,
	mdQuarterlySale,
	mdQuarterlyClaim,
	mdAnnualSale,
	mdAnnualClaim,
	mdAnnualDistribution,
	sdQuarterlyFinance,
	sdQuarterlyInvestment,
	sdAnnualAuditedFinance,
	sdAnnualUnauditedFinance,
	sdAnnualAuditedInvestment,
	monthlyFileReport,
	quarterlyFileReport,
	semesterlyFileReport,
	annuallyFileReport,
];

const periodMapping = {
	MonthlyFileReport: 'monthly',
	QuarterlyFileReport: 'quarterly',
	SemesterlyFileReport: 'semesterly',
	AnnuallyFileReport: 'annually',
};

export {
	reportTypes,
	mdMonthlySale,
	mdMonthlyClaim,
	mdMonthlyDistribution,
	mdQuarterlySale,
	mdQuarterlyClaim,
	mdAnnualSale,
	mdAnnualClaim,
	mdAnnualDistribution,
	sdQuarterlyFinance,
	sdQuarterlyInvestment,
	sdAnnualAuditedFinance,
	sdAnnualUnauditedFinance,
	sdAnnualAuditedInvestment,
	monthlyFileReport,
	quarterlyFileReport,
	semesterlyFileReport,
	annuallyFileReport,
	periodMapping,
};
